// generated by genversion
export var version = '3.2.3';
//# sourceMappingURL=version.js.map